<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择客户"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="customers/distinctList">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="查询">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
          <vm-search label="公司代码">
            <el-input v-model.trim="filter.companyNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column align="center" prop="customerNo" label="客户编号" width="70px"/>
      <el-table-column align="center" prop="customerName" label="客户名称"/>
      <el-table-column align="center" prop="outerNo" label="外部编号" width="90px"/>
      <el-table-column align="center" prop="address" label="所属区域"/>
      <el-table-column align="center" prop="telephone" label="电话" width="150px"/>
      <el-table-column align="center" prop="companyNo" label="公司代码" width="150px"/>
      <el-table-column label="操作" align="center" width="90px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name:"CustomerSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        filter: {
          parentId: "",
          filter: "",
          companyNo: "S100",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
